"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPersonalCreditCards = exports.fetchBusinessCreditCards = exports.PERSONAL_CREDIT_CARDS_SUCCESS = exports.PERSONAL_CREDIT_CARDS_QUERY = exports.PERSONAL_CREDIT_CARDS_LOAD = exports.PERSONAL_CREDIT_CARDS_FAILURE = exports.BUSINESS_CREDIT_CARDS_SUCCESS = exports.BUSINESS_CREDIT_CARDS_LOAD = exports.BUSINESS_CREDIT_CARDS_FAILURE = void 0;

var _utils = require("@navinc/utils");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var CREDIT_CARD_FIELDS = "\nfragment creditCardFields on CreditCard {\n  __typename\n  aprs {\n    introPurchaseApr {\n      description\n      title\n    }\n    purchaseApr {\n      description\n      title\n    }\n  }\n  category\n  fees {\n    annualFee {\n      description\n      title\n    }\n    foreignTransactionFee {\n      description\n      title\n    }\n  }\n  id\n  image {\n    standard\n    high\n  }\n  issuer\n  marketingCopy\n  name\n  navEditorial {\n    cons\n    pros\n    summary\n  }\n  rewards {\n    rewardsRate {\n      description\n      descriptionShort\n      title\n    }\n    welcomeOffer {\n      description\n      descriptionShort\n      title\n    }\n  }\n  rtid\n  terms {\n    link\n    linkText\n    partnerText\n    title\n  }\n}\n";
var PERSONAL_CREDIT_CARDS = "\npersonalCreditCards(\n  businessId: $businessId,\n  customerData: $customerData,\n  collection: $collection\n) {\n  ...creditCardFields\n  applyUrl\n  guid\n  matchFactor\n  mfSource\n  qualifiers {\n    evaluation\n    longText\n    shortText\n    title\n    value\n  }\n  tags {\n    name\n    value\n  }\n}\n";
var PERSONAL_CREDIT_CARDS_QUERY = "\nquery personalCreditCards(\n  $businessId: Int,\n  $customerData: CustomerData,\n  $collection: String\n) {\n  ".concat(PERSONAL_CREDIT_CARDS, "\n}\n").concat(CREDIT_CARD_FIELDS, "\n");
exports.PERSONAL_CREDIT_CARDS_QUERY = PERSONAL_CREDIT_CARDS_QUERY;
var PERSONAL_CREDIT_CARDS_LOAD = 'PERSONAL_CREDIT_CARDS_LOAD';
exports.PERSONAL_CREDIT_CARDS_LOAD = PERSONAL_CREDIT_CARDS_LOAD;
var PERSONAL_CREDIT_CARDS_FAILURE = 'PERSONAL_CREDIT_CARDS_FAILURE';
exports.PERSONAL_CREDIT_CARDS_FAILURE = PERSONAL_CREDIT_CARDS_FAILURE;
var PERSONAL_CREDIT_CARDS_SUCCESS = 'PERSONAL_CREDIT_CARDS_SUCCESS';
exports.PERSONAL_CREDIT_CARDS_SUCCESS = PERSONAL_CREDIT_CARDS_SUCCESS;

var fetchPersonalCreditCards = function fetchPersonalCreditCards() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      businessId = _ref.businessId,
      _ref$customerData = _ref.customerData,
      customerData = _ref$customerData === void 0 ? fetchPersonalCreditCards.getConfig().customerData : _ref$customerData,
      _ref$collection = _ref.collection,
      collection = _ref$collection === void 0 ? fetchPersonalCreditCards.getConfig().collection : _ref$collection,
      _ref$apiUrl = _ref.apiUrl,
      apiUrl = _ref$apiUrl === void 0 ? fetchPersonalCreditCards.getConfig().apiUrl : _ref$apiUrl,
      _ref$authToken = _ref.authToken,
      authToken = _ref$authToken === void 0 ? fetchPersonalCreditCards.getConfig().authToken || _jsCookie["default"].get('token') : _ref$authToken,
      _ref$clientName = _ref.clientName,
      clientName = _ref$clientName === void 0 ? fetchPersonalCreditCards.getConfig().clientName || 'ent-web' : _ref$clientName;

  return {
    loadActionTypeOrCreator: PERSONAL_CREDIT_CARDS_LOAD,
    failureActionTypeOrCreator: PERSONAL_CREDIT_CARDS_FAILURE,
    successActionTypeOrCreator: PERSONAL_CREDIT_CARDS_SUCCESS,
    requestParams: {
      body: {
        query: PERSONAL_CREDIT_CARDS_QUERY,
        variables: {
          businessId: Number(businessId),
          customerData: customerData,
          collection: collection
        }
      },
      headers: {
        Authorization: "Bearer ".concat(authToken),
        'Client-Name': clientName
      },
      method: 'POST',
      url: "".concat(apiUrl)
    },
    type: _utils.FETCH
  };
};

exports.fetchPersonalCreditCards = fetchPersonalCreditCards;
var BUSINESS_CREDIT_CARDS = "\nbusinessCreditCards(\n  customerData: $customerData,\n  excludeIssuers: $excludeIssuers,\n  collection: $collection\n) {\n  ...creditCardFields\n  applyUrl\n  guid\n  matchFactor\n  qualifiers {\n    evaluation\n    longText\n    shortText\n    title\n    value\n  }\n  tags {\n    name\n    value\n  }\n}\n";
var BUSINESS_CREDIT_CARDS_QUERY = "\nquery businessCreditCards(\n  $customerData: CustomerData,\n  $excludeIssuers: [String],\n  $collection: String\n) {\n  ".concat(BUSINESS_CREDIT_CARDS, "\n}\n").concat(CREDIT_CARD_FIELDS, "\n");
var BUSINESS_CREDIT_CARDS_LOAD = 'BUSINESS_CREDIT_CARDS_LOAD';
exports.BUSINESS_CREDIT_CARDS_LOAD = BUSINESS_CREDIT_CARDS_LOAD;
var BUSINESS_CREDIT_CARDS_FAILURE = 'BUSINESS_CREDIT_CARDS_FAILURE';
exports.BUSINESS_CREDIT_CARDS_FAILURE = BUSINESS_CREDIT_CARDS_FAILURE;
var BUSINESS_CREDIT_CARDS_SUCCESS = 'BUSINESS_CREDIT_CARDS_SUCCESS';
exports.BUSINESS_CREDIT_CARDS_SUCCESS = BUSINESS_CREDIT_CARDS_SUCCESS;

var fetchBusinessCreditCards = function fetchBusinessCreditCards() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$customerData = _ref2.customerData,
      customerData = _ref2$customerData === void 0 ? fetchBusinessCreditCards.getConfig().customerData : _ref2$customerData,
      _ref2$excludeIssuers = _ref2.excludeIssuers,
      excludeIssuers = _ref2$excludeIssuers === void 0 ? fetchBusinessCreditCards.getConfig().excludeIssuers : _ref2$excludeIssuers,
      _ref2$collection = _ref2.collection,
      collection = _ref2$collection === void 0 ? fetchBusinessCreditCards.getConfig().collection : _ref2$collection,
      _ref2$apiUrl = _ref2.apiUrl,
      apiUrl = _ref2$apiUrl === void 0 ? fetchBusinessCreditCards.getConfig().apiUrl : _ref2$apiUrl,
      _ref2$authToken = _ref2.authToken,
      authToken = _ref2$authToken === void 0 ? fetchBusinessCreditCards.getConfig().authToken || _jsCookie["default"].get('token') : _ref2$authToken,
      _ref2$clientName = _ref2.clientName,
      clientName = _ref2$clientName === void 0 ? fetchBusinessCreditCards.getConfig().clientName || 'ent-web' : _ref2$clientName;

  return {
    loadActionTypeOrCreator: BUSINESS_CREDIT_CARDS_LOAD,
    failureActionTypeOrCreator: BUSINESS_CREDIT_CARDS_FAILURE,
    successActionTypeOrCreator: BUSINESS_CREDIT_CARDS_SUCCESS,
    requestParams: {
      method: 'POST',
      url: "".concat(apiUrl),
      body: {
        query: BUSINESS_CREDIT_CARDS_QUERY,
        variables: {
          customerData: customerData,
          excludeIssuers: excludeIssuers,
          collection: collection
        }
      },
      headers: {
        Authorization: "Bearer ".concat(authToken),
        'Client-Name': clientName
      }
    },
    type: _utils.FETCH
  };
};

exports.fetchBusinessCreditCards = fetchBusinessCreditCards;
//# sourceMappingURL=actions.js.map